import type { MessengerFeatureConfig } from '../type';

export const messenger: Partial<MessengerFeatureConfig> = {
    threadPollingInterval: 10000,
    maximumAttachmentsLimit: 5,
    totalAttachmentsSizeLimitInMBs: 50,
    extendedAllowedAttachmentExtensions: ['rtf', 'ppt', 'pptx'],
    attachmentNameEncoded: true,
};
